import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClPaper from '../ClPaper';
import ClTypography from '../ClTypography';
import { ClSnackbarColor } from '../ClSnackbar';

@Component({
  components: {
    ClPaper,
    ClTypography
  }
})
export default class ClSnackbarContent extends Vue {
  @Prop({
    type: String as () => ClSnackbarColor,
    default: 'default'
  })
  public color!: ClSnackbarColor;

  @Prop({
    type: String,
    default: ''
  })
  public message!: string;
}
